export default __webpack_public_path__ + "static/development-5b5380d28aa168d4a6d81ba695663762.svg";